import { GzExchangeProtectionGeneralWebComponent } from './component/GzExchangeProtectionGeneralWebComponent';

export { GzExchangeProtectionGeneralWebComponent };
